export default __webpack_public_path__ + "static/photo-dh-2babdcc3a7b5897a07ea341b037b9857.jpg";